import { patchPreferredLanguage } from "@/api/meApi";
import { meKeys } from "@/api/meKeys";
import i18n from "@/lib/i18n";
import { queryClient } from "@/lib/queryClient";
import { normalizeUiLanguage, type UiLanguage } from "@/lib/uiLanguage";
import { useAuthStore } from "@/store/authStore";
import type { MeResponse } from "@/types/api/me";

function writePreferredLanguageCache(language: UiLanguage): void {
  queryClient.setQueryData(meKeys.detail(), (previous: MeResponse | undefined) =>
    previous ? { ...previous, preferredLanguage: language } : previous,
  );
}

/** Change UI language for this person: local i18n plus account when signed in. */
export async function setUiLanguage(lng: string): Promise<void> {
  const language = normalizeUiLanguage(lng);
  await i18n.changeLanguage(language);
  if (!useAuthStore.getState().session) return;
  try {
    const saved = await patchPreferredLanguage(language);
    writePreferredLanguageCache(saved);
  } catch {
    /* Language is already applied locally. */
  }
}

export function cachePreferredLanguage(language: UiLanguage): void {
  writePreferredLanguageCache(language);
}
